import { Component } from '@angular/core';
import { IonicPage, ToastController, NavController, NavParams } from 'ionic-angular';
import { CoolLocalStorage } from 'angular2-cool-storage';
import {AngularFireDatabase,  FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {Score} from '../../models/user';
import {AngularFireAuth} from 'angularfire2/auth';
import {LoginPage} from '../login/login';
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {

  game: FirebaseObjectObservable<any[]>;
  localStorage: CoolLocalStorage;
  score = {} as Score;
  show: Boolean = false;

  constructor(private toastCtrl: ToastController, private afauth: AngularFireAuth, localStorage: CoolLocalStorage, public navCtrl: NavController, public navParams: NavParams, private db: AngularFireDatabase) {
    const authObserver = afauth.authState.subscribe( user => {
      if (user == null) {
        this.navCtrl.setRoot(LoginPage);
        authObserver.unsubscribe();
      }
      else
      {
          this.localStorage = localStorage;
          this.game  = db.object('/v2/game/' + this.localStorage.getItem('code'));

          db.object('/v2/game/' + this.localStorage.getItem('code') + "/show")
          .subscribe(data => {
                this.show = data.$value;

          })
        }})


  }


  updateData()
  {
    this.game.update(this.score);
  }

  update()
  {
      this.db.object('/v2/game/' + this.localStorage.getItem('code') + "/show").set(this.show);
  }

  updateQ()
  {
     var u :Array<Boolean> = [];
     var n :Array<Boolean> = [];

     if(this.localStorage.getItem('ques'))
     {
       u = JSON.parse(this.localStorage.getItem('ques'));

       for(var i = 0; i < u.length; i++)
       {
           n.push(false);
       }
        console.log(u);


        this.localStorage.setItem('ques', JSON.stringify(n));
        this.presentToast("Questions Refreshed");

     }
     else
     {
          this.presentToast("No questions have been asked!")
     }
  }

  presentToast(msg) {
  let toast = this.toastCtrl.create({
    message: msg,
    duration: 3000,
    position: 'top'
  });

  toast.onDidDismiss(() => {
    console.log('Dismissed toast');
  });

  toast.present();
}

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts